import { S2 } from 'select2';
import { Plugin } from '../Plugin';

const NAME = 'select2';

class Select2 extends Plugin {
  getName() {
    return NAME;
  }

  static getDefaults() {
    return {
      width: 'style'
    };
  }

  render() {
    this.options.dropdownParent = this.$el.closest('.form-group');
    super.render();
  }
}

Plugin.register(NAME, Select2);

export default Select2;
